import React, {Component} from 'react';
import {Prompt} from 'react-router-dom';
import {EditorState, RichUtils, convertToRaw, convertFromRaw, ContentState} from 'draft-js';
import Editor from 'draft-js-plugins-editor';
import createImagePlugin from 'draft-js-image-plugin';
import createFocusPlugin from 'draft-js-focus-plugin';
import 'draft-js-image-plugin/lib/plugin.css';

//import styles
import '../../../scss/editor.scss';
import 'draft-js-focus-plugin/lib/plugin.css';
import { FaBold, FaItalic, FaUnderline, 
         FaParagraph, FaListOl, FaListUl,
         FaCode, FaIndent, FaEraser, 
         FaTrashAlt, FaClone } from 'react-icons/fa';

import SampleData from './get-sample-data';


const imagePlugin = createImagePlugin();
const focusPlugin = createFocusPlugin();

const plugins = [focusPlugin, imagePlugin];

class ContentEditor extends Component {
  constructor(props){
    super(props);

    this.state = {
      editorState: EditorState.createEmpty(),
      documentKey: '',
      selectedDocumentKey: '',
      product: 'wdelite', 
      section: '', 
      title: '', 
      homepage: 'none', 
      documentStatus: 'new', //edit | new | saved | unsaved
      documentList: [],
      isAuthenticated: null,
      userProfile: {}
    }

    this.onEditorContentChange = this.onEditorContentChange.bind(this);
    this.onEditorBlockStyleChange = this.onEditorBlockStyleChange.bind(this);
    this.onEditorInlineStyleChange = this.onEditorInlineStyleChange.bind(this);
    this.onEditorHeadingSelectChange = this.onEditorHeadingSelectChange.bind(this);

    this.onDocumentSave = this.onDocumentSave.bind(this);
    this.onDocumentChange = this.onDocumentChange.bind(this);
    this.onFormValueChange = this.onFormValueChange.bind(this);
    this.deleteDocument = this.deleteDocument.bind(this);
    this.insertDocument = this.insertDocument.bind(this);
    this.updateDocument = this.updateDocument.bind(this);
    this.cloneDocument = this.cloneDocument.bind(this);

    this.displayContentJSON = this.displayContentJSON.bind(this);
    this.loadToEditorJSON = this.loadToEditorJSON.bind(this);
    this.clearEditor = this.clearEditor.bind(this);

    this.checkAuth = this.checkAuth.bind(this);

    this.getDocumentDetail = this.getDocumentDetail.bind(this);
    this.getDocumentList = this.getDocumentList.bind(this);

    this.clearState =this.clearState.bind(this);
    this.createDataDocument = this.createDataDocument.bind(this);
  }

  componentDidMount(){
    this.checkAuth();
    this.getDocumentList();
  }


  // =============================
  // Get Data Handlers
  // =============================
  getDocumentDetail(){

    const docId = this.state.selectedDocumentKey;
    if(!docId.length > 0 || docId === 'new'){ return; }

    //get document by key value
    let apiUrl = `${window.location.protocol}//${window.location.host}/api/pages/${docId}`;
    fetch(apiUrl)
      .then(res => res.json())
      .then(data => {
        this.setState({
          editorState: EditorState.createWithContent(convertFromRaw(data.documentContent)),
          documentKey: data.document.key,
          product: data.product.key, 
          section: data.section.title, 
          title: data.document.title,
          homepage: (data.isProductHomePage)? 'product' : (data.isSectionHomePage) ? 'section' : 'none', 
          documentStatus: 'edit'
        });
      });
  }

  getDocumentList(){
    //get list of documents to edit by product
    const product = 'wdelite';
    let apiUrl = `${window.location.protocol}//${window.location.host}/api/admin/products/${product}/documents`;
    
    fetch(apiUrl)
    .then(res => res.json())
    .then(data => {
      this.setState({
        documentList: data
      });
    });
  }


  // =============================
  // Editor Event Handlers
  // =============================
  onEditorBlockStyleChange(e, style){
    e.preventDefault();
    this.onEditorContentChange(RichUtils.toggleBlockType(
      this.state.editorState, style));
  }

  onEditorInlineStyleChange(e, style){
    e.preventDefault();
    this.onEditorContentChange(RichUtils.toggleInlineStyle(
      this.state.editorState, style));
  }

  onEditorHeadingSelectChange(e){
    const elem = e.target;
    const style = elem.value;
    this.onEditorBlockStyleChange(e, style);
    elem.selectedIndex = 0;
  }

  onEditorContentChange(editorState){
    this.setState({
      editorState: editorState
    });
  }

  // =============================
  // Authentication
  // =============================
  checkAuth(){
    let apiUrl = `${window.location.protocol}//${window.location.host}/auth/authenticated`;
    fetch(apiUrl)
    .then(res => res.json())
    .then(({isAuthenticated, userProfile}) => {
      if(!isAuthenticated) {
        //redirect to login page
        this.props.history.push('/login');
        return;
      }
      this.setState({
        isAuthenticated,
        userProfile
      });
    });
  }


  // =============================
  // Form Event Handlers
  // =============================
  onDocumentSave(e){

    //check for edit or insert
    const isEdit = (this.state.documentKey.length > 0);

    if(isEdit){
      this.updateDocument(e);
    } else {
      this.insertDocument(e);
    }

  }

  onFormValueChange(e) {
    this.setState({
      [e.target.name]: e.target.value 
    });
  }

  onDocumentChange(e){
    this.clearState();
    this.setState({
      [e.target.name]: e.target.value 
    },() => {
      if(this.state.selectedDocumentKey.length > 0){
        this.getDocumentDetail();
      }
    });
  }

  deleteDocument(e){

    const confirm = window.confirm("Are you sure you want to delete this document?");
    if(!confirm){return;}

    const docKey = this.state.documentKey;
    const docName = this.state.title;

    //call api route to delete document
    const apiUrl = `${window.location.protocol}//${window.location.host}/api/admin/document`;
    fetch(apiUrl, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'DELETE',
        credentials: 'include',
        body: JSON.stringify({id: docKey})
    })
    .then(() => {
      this.clearState();
      this.getDocumentList(); //refresh document list 
    })
    .then(() => alert(`The document "${docName}" has been deleted.`));

  }

  updateDocument(e){

    //create doc obj and submit to api
    const doc = this.createDataDocument();
 
    //call api
    fetch(`${window.location.protocol}//${window.location.host}/api/admin/document/${this.state.documentKey}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'put',
        body: JSON.stringify(doc)
    }).then((res) => res.json())
    .then((data) => {
      //update state with return values
      this.setState({
        editorState: EditorState.createWithContent(convertFromRaw(data.documentContent)),
        documentKey: data.document.key,
        selectedDocumentKey: data.document.key,
        product: data.product.title, 
        section: data.section.title, 
        title: data.document.title,
        homepage: (data.isProductHomePage) ? 'product' : (data.isSectionHomePage) ? 'section' : 'none', 
        documentStatus: 'edit'
      });
    })
    .then(() => this.getDocumentList()) //now get updated document detail
    .then(() => alert("Your document has been updated."))
    .catch((err)=>{
      console.log(err)
    });

  }

  insertDocument(e) {

    //create doc obj and submit to api
    const doc = this.createDataDocument();
 
    //call api
    fetch(`${window.location.protocol}//${window.location.host}/api/admin/document`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'post',
        body: JSON.stringify(doc)
    }).then((res) => res.json())
    .then(() => this.getDocumentList())
    .then(() => alert("Your document has been saved."))
    .catch((err)=>{
      console.log(err)
    });
  }

  cloneDocument() {
    // leaves stae as is except for document key
    // also appends a ' [COPY]' to the end of the title

    this.setState({
      documentKey:'',
      documentStatus: 'new',
      selectedDocumentKey:'',
      title:this.state.title + ' [COPY]'
    });

  }


  // =============================
  // Helpers
  // =============================

  displayContentJSON(){
    return JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent()), null, 1);
  }

  loadToEditorJSON(e){
    e.preventDefault();
    const data = SampleData.getJSON();
    const contentState = convertFromRaw(data);
    this.setState({editorState: EditorState.createWithContent(contentState)});
  } 

  clearEditor(e){
    e.preventDefault();
    this.setState({editorState: EditorState.createEmpty()});
  }

  setDocumentList(){
    const docs = this.state.documentList;
    if(docs.length === 0) {return;}
    let options = _.chain(docs)
      .sortBy('section.title')
      .groupBy('section.title')
      .map((value, key) => {
        //this is an array of groups
        //each group is an array of docs
        //map the groups into <optgroup> of <option>
        const sorted = _.sortBy(value, 'document.title');
        return (
          <optgroup label={sorted[0].section.title}>
            {
              sorted.map((d, idx) => {
                return <option
                          key={'doc-item-' + (idx+1)}
                          value={d.document.key}>
                            {d.document.title}
                        </option>
              })
            }
          </optgroup>
        )
      })
      .value();

    //add new document option to top of list
    options.unshift(
      <optgroup label="New Document">
        <option key={'doc-item-0'} value="new">Add new document</option>
      </optgroup>
    );
    return options;
  }

  clearState(){
    this.setState({
      editorState: EditorState.createEmpty(),
      documentKey: '',
      selectedDocumentKey: '',
      product: 'wdelite', 
      section: '', 
      title: '',
      homepage: 'none', 
      documentStatus: ''
    });
  }

  createDataDocument(){
    return {
      product: this.state.product,
      section: this.state.section,
      title: this.state.title,
      isProductHomePage: (this.state.homepage === 'product'),
      isSectionHomePage: (this.state.homepage === 'section'),
      documentContent: convertToRaw(this.state.editorState.getCurrentContent())
    }
  }


  // =============================
  // Render
  // =============================
  render(){
    if(this.state.isAuthenticated === true) {
      return (
        <div>
          <h1>Content Editor</h1>
            <div className="editor">  
              <div className="card bg-light detail-content">
                <div className="form-container">
                <div className="form-group">
                  <label htmlFor="docs">Document:</label>
                  <select 
                    name="selectedDocumentKey" 
                    className="form-control"
                    value={this.state.selectedDocumentKey}
                    onChange={this.onDocumentChange}>{this.setDocumentList()}</select>
                </div>
                  <div className="form-group">
                    <label htmlFor="product">Product:</label>
                    <select name="product" className="form-control" value={this.state.product} onChange={this.onFormValueChange}>
                      <option value="wdelite">WatchDOG Elite</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="section">Section:</label>
                    <select name="section" className="form-control" value={this.state.section} onChange={this.onFormValueChange}>
                      <option value="">Choose a section</option>
                      <option value="Controls and Response">Controls and Response</option>
                      <option value="Getting Started">Getting Started</option>
                      <option value="Watch List Screening">Watch List Screening</option>
                      <option value="Identity Verification">Identity Verification</option>
                      <option value="Policies and Procedures">Policies and Procedures</option>
                      <option value="SmartRisk IQ">SmartRisk IQ</option>
                      <option value="Vendor Management">Vendor Management</option>
                      <option value="WatchDOG Customer Support">WatchDOG Customer Support</option>
                      <option value="WatchDOG System Administration">WatchDOG System Administration</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="title">Page title:</label>
                    <input 
                      name="title"
                      className="form-control" 
                      placeholder="Enter page title" 
                      value={this.state.title}
                      onChange={this.onFormValueChange}
                    />
                  </div>
                  <div class="form-group">
                    <label>Set as home page:</label>
                    <div class="radio-group">
                      <div>
                        <input type="radio"
                          id="radProduct"
                          name="homepage"
                          value="product"
                          checked={this.state.homepage === 'product'}
                          onChange={this.onFormValueChange}
                        />
                        <label for="radProduct">Product Home Page</label>
                      </div>
                      <div>
                        <input type="radio"
                          id="radSection"
                          name="homepage"
                          value="section"
                          checked={this.state.homepage === 'section'}
                          onChange={this.onFormValueChange}
                        />
                        <label for="radSection">Section Home Page</label>
                      </div>
                      <div>
                        <input type="radio"
                          id="radNone"
                          name="homepage"
                          value="none"
                          checked={this.state.homepage === 'none'}
                          onChange={this.onFormValueChange}
                        />
                        <label for="radNone">None</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="card">
                <div className="card-header clear-top">
                  <div className="button-bar">
                    <div className="button-bar-section">
                      <select onChange={this.onEditorHeadingSelectChange}>
                        <option value="unstyled">Styles</option>
                        <option value="header-two">Heading 1</option>
                        <option value="header-three">Heading 2</option>
                        <option value="header-four">Heading 3</option>
                      </select>
                    </div>
                    <div className="button-bar-section">
                      <button title="Bold" onClick={(e) => this.onEditorInlineStyleChange(e,'BOLD')}><FaBold/></button>
                      <button title="Italic" onClick={(e) => this.onEditorInlineStyleChange(e, 'ITALIC')}><FaItalic/></button>
                      <button title="Underline" onClick={(e) => this.onEditorInlineStyleChange(e, 'UNDERLINE')}><FaUnderline/></button>
                    </div>
                    <div className="button-bar-section">
                      <button title="Paragraph" onClick={(e) => this.onEditorBlockStyleChange(e, 'paragraph')}><FaParagraph/></button>
                      <button title="Unordered List" onClick={(e) => this.onEditorBlockStyleChange(e, 'unordered-list-item')}><FaListUl/></button>
                      <button title="Numbered List" onClick={(e) => this.onEditorBlockStyleChange(e, 'ordered-list-item')}><FaListOl/></button>
                    </div>
                    <div className="button-bar-section">
                      <button title="Block Quote" onClick={(e) => this.onEditorBlockStyleChange(e, 'blockquote')}><FaIndent/></button>
                      <button title="Code block" onClick={(e) => this.onEditorBlockStyleChange(e, 'code-block')}><FaCode/></button>
                      <button title="Remove block style" onClick={(e) => this.onEditorBlockStyleChange(e, 'unstyled')}><FaEraser/></button>
                    </div>
                    <div className="button-bar-section">
                      <button title="Clone document" 
                              disabled={(this.state.product == '' ||
                                         this.state.section === '' ||
                                         this.state.title === '') && 'disabled'}        
                              onClick={(this.state.product !== '' ||
                                        this.state.section !== '' ||
                                        this.state.title !== '') && this.cloneDocument}><FaClone/></button>
                    </div>
                    <div class="loader-buttons">
                      <button onClick={this.loadToEditorJSON}>Load JSON</button>
                      <button onClick={this.clearEditor}>Clear Content</button>
                    </div>
                    <div class="op-buttons">
                      <button title="Save document"
                              onClick={(this.state.product !== '' ||
                                        this.state.section !== '' ||
                                        this.state.title !== '') && this.onDocumentSave} 
                              disabled={(this.state.product === '' ||
                                         this.state.section === '' ||
                                         this.state.title === '') && 'disabled'}
                              className="btn-save-document">Save Changes</button>
                      <button title="Delete document"
                              onClick={(this.state.documentKey !== '') && this.deleteDocument} 
                              disabled={(this.state.documentKey === '') && 'disabled'} 
                              className="btn-delete-document" ><FaTrashAlt/></button>
                    </div>
                  </div>
                </div>
                <div 
                  className="editor-content" 
                  onClick={()=>{document.querySelector(".public-DraftEditor-content").focus()}}>         
                  <Editor
                    name="documentContent"
                    onChange={this.onEditorContentChange} 
                    editorState={this.state.editorState}
                    plugins={plugins}
                    ref={(element) => { this.editor = element; }}  
                  />
                </div>
              </div>
            </div>

          <div className="view-wrapper">
            <div className="left">
              <h2>JSON View</h2>
              <div className="card">
                <pre>{this.displayContentJSON()}</pre>
              </div>
            </div>
            
          </div>
        </div>
      );
    } else {
      return (<div></div>);
    }
  }
}

export default ContentEditor;
